<template>

  <div class="padded">

    <el-row :gutter="24">

      <el-col v-if="chart.length > 0" v-for="(c, i) in chart" :key="i" :sm="24"  :md="12" :lg="mdAbove" align="center">
        <pie-chart v-if="chart[i].total > 0" :title="chart[i].title" :data="chart[i].data" :colors="chart[i].colors" :legend="posLegend" />
      </el-col>

    </el-row>

  </div>

</template>

<script>

import ChartMixins from '@/mixins/ChartMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [ChartMixins, NumberMixins],

  props: {


    stats: {
      type: Object,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    posLegend: {
      type: String,
      default: 'bottom'
    }

  },

  methods: {

    init () {
      this.chart = null

      this.chart = this.preparePieChart([
        [['Rejected (' + this.formatInteger(this.rtxStats.rtaRejected) + ')', this.rtxStats.rtaRejected], ['Active (' + this.formatInteger(this.rtxStats.rta) + ')', this.rtxStats.rta], ['Closed (' + this.formatInteger(this.rtxStats.rtaClosed) + ')', this.rtxStats.rtaClosed]],
        [['Rejected (' + this.formatInteger(this.rtxStats.rtsRejected) + ')', this.rtxStats.rtsRejected], ['Active (' + this.formatInteger(this.rtxStats.rts) + ')', this.rtxStats.rts], ['Closed (' + this.formatInteger(this.rtxStats.rtsClosed) + ')', this.rtxStats.rtsClosed]],
        [['Rejected (' + this.formatInteger(this.rtxStats.rtuRejected) + ')', this.rtxStats.rtuRejected], ['Active (' + this.formatInteger(this.rtxStats.rtu) + ')', this.rtxStats.rtu], ['Closed (' + this.formatInteger(this.rtxStats.rtuClosed) + ')', this.rtxStats.rtuClosed]],
        [['Rejected (' + this.formatInteger(this.rtxStats.rtbRejected) + ')', this.rtxStats.rtbRejected], ['Active (' + this.formatInteger(this.rtxStats.rtb) + ')', this.rtxStats.rtb], ['Closed (' + this.formatInteger(this.rtxStats.rtbClosed) + ')', this.rtxStats.rtbClosed]],
      ], ['#E6A23C74', '#409EFF', '#67C23A74'], ['RTA|#E6A23C', 'RTS|#67C23A', 'RTU', 'RTB|#909399'], true, 1)
    }

  },



  watch: {
    stats: function (s) {
      this.stats = s
    }

  },


  computed: {
    mdAbove: function () {
      if (this.chart) {
        return Math.round(24 / this.chart.length, 0)
      } else {
        return 12
      }


    }
  },



  data () {
    return {
      chart: null,
      rtxStats: (this.stats ? this.stats : this.getStats())
    }
  },

  created () {

    this.init()

  }

}

</script>



// WEBPACK FOOTER //
// RequestsChart.vue?7e1a9a1e